var SettingsActionsModalController = /** @class */ (function () {
    function SettingsActionsModalController() {
        // this.actionType = this.resolve.actionType;
        // this.actionLabel = this.resolve.actionLabel;
        // this.activityMap = this.resolve.activityMap;
        // this.companyId = this.resolve.companyId;
        // this.isSharedClient = this.resolve.isSharedClient;
        // this.context = this.resolve.context;
    }
    SettingsActionsModalController.prototype.$onInit = function () {
        this.actionType = this.resolve.actionType;
        this.actionLabel = this.resolve.actionLabel;
        this.activityMap = this.resolve.activityMap;
        this.companyId = this.resolve.companyId;
        this.isSharedClient = this.resolve.isSharedClient;
        this.context = this.resolve.context;
        this.callbackObject = { callbackType: 'cancel', entity: {} };
    };
    SettingsActionsModalController.prototype.closeModal = function () {
        this.modalInstance.close(this.callbackObject);
    };
    SettingsActionsModalController.prototype.dismissModal = function () {
        this.modalInstance.dismiss('cancel');
    };
    return SettingsActionsModalController;
}());
// import * as TEMPLATE from './settings-actions-modal.html';
import * as TEMPLATE from 'raw-loader!./settings-actions-modal.html';
export var SettingsActionsModalComponent = {
    selector: 'settingsActionsModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: SettingsActionsModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/settings/settingsActionsModal/settings-actions-modal.html'
    }
};
//# sourceMappingURL=settings-actions-modal.component.js.map